// extracted by mini-css-extract-plugin
export default {"mNav":"tab_mNav__jHHBS","navBar":"tab_navBar__dJBlq","navItem":"tab_navItem__5cnyv","select":"tab_select__ED1dO"};